import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { SearchAlert } from 'ha/services/apiV2/types/SearchAlert';
import { APIV2_URL } from './constants';

interface GetSearchAlertsParams {
  userId: number;
  city: string;
  countryCode: string;
}

interface GetSearchAlertsResponse {
  alerts: SearchAlert[];
}

export type GetSearchAlertsCall = (
  params: GetSearchAlertsParams,
) => Promise<{ data: GetSearchAlertsResponse }>;

export default (makeCall: MakeCall) => ({
  userId,
  city,
  countryCode,
}: GetSearchAlertsParams) =>
  makeCall<GetSearchAlertsResponse>(
    'GET',
    `${APIV2_URL}/user/${userId}/search-alerts`,
    {
      query: {
        city,
        countryCode,
      },
    },
  );
